import 'reflect-metadata';
import {jsonObject, jsonMember, jsonArrayMember} from 'typedjson';

@jsonObject
export class Dhcp4Options {

  @jsonMember({name: 'broadcast_address'})
  public broadcastAddress!: string;

  @jsonMember({name: 'dad_wait_time'})
  public dadWaitTime!: string;

  @jsonMember({name: 'dhcp_lease_time'})
  public dhcpLeaseTime!: string;

  @jsonMember({name: 'dhcp_message_type'})
  public dhcpMessageType!: string;

  @jsonMember({name: 'dhcp_server_identifier'})
  public dhcpServerIdentifier!: string;

  @jsonMember({name: 'domain_name_servers'})
  public domainNameServers!: string;

  @jsonMember({name: 'expiry'})
  public expiry!: string;

  @jsonMember({name: 'ip_address'})
  public ipAddress!: string;

  @jsonMember({name: 'network_number'})
  public networkNumber!: string;

  @jsonMember({name: 'next_server'})
  public nextServer!: string;

  @jsonMember({name: 'ntp_servers'})
  public ntpServers!: string;

  @jsonMember({name: 'requested_broadcast_address'})
  public requestedBroadcastAddress!: string;

  @jsonMember({name: 'requested_domain_name'})
  public requestedDomainName!: string;

  @jsonMember({name: 'requested_domain_name_servers'})
  public requestedDomainNameServers!: string;

  @jsonMember({name: 'requested_host_name'})
  public requestedHostName!: string;

  @jsonMember({name: 'requested_ms_classless_static_routes'})
  public requestedMsClasslessStaticRoutes!: string;

  @jsonMember({name: 'requested_netbios_name_servers'})
  public requestedNetbiosNameServers!: string;

  @jsonMember({name: 'requested_netbios_scope'})
  public requestedNetbiosScope!: string;

  @jsonMember({name: 'requested_ntp_servers'})
  public requestedNtpServers!: string;

  @jsonMember({name: 'requested_rfc3442_classless_static_routes'})
  public requestedRfc3442ClasslessStaticRoutes!: string;

  @jsonMember({name: 'requested_root_path'})
  public requestedRootPath!: string;

  @jsonMember({name: 'requested_routers'})
  public requestedRouters!: string;

  @jsonMember({name: 'requested_static_routes'})
  public requestedStaticRoutes!: string;

  @jsonMember({name: 'requested_subnet_mask'})
  public requestedSubnetMask!: string;

  @jsonMember({name: 'requested_time_offset'})
  public requestedTimeOffset!: string;

  @jsonMember({name: 'requested_wpad'})
  public requestedWpad!: string;

  @jsonMember({name: 'routers'})
  public routers!: string;

  @jsonMember({name: 'subnet_mask'})
  public subnetMask!: string;
}

@jsonObject
export class Dhcp4Status {
  @jsonMember({name: 'options'})
  public Options!: Dhcp4Options;
}
